<template>
    <div class="tr">
        <MenuSection>
            <ListItem link="search">Rent a Tool</ListItem>
            <ListItem link="error-page">Help</ListItem>
            <ListItem link="error-page">Insurance</ListItem>
            <ListItem link="error-page">Reviews</ListItem>
        </MenuSection>
        <MenuSection>
            <ListItem link="listing-start">List My Tools</ListItem>
        </MenuSection>
        <MenuSection class="pa3">
            <TooliabaButton @click="$emit('loginClick')">Log In</TooliabaButton>
        </MenuSection>
        <MenuSection class="pa3">
            <img class="pl2" src="@/assets/img/social-media/icon_menu_facebook_black.svg"/>
            <img class="pl2" src="@/assets/img/social-media/icon_menu_twitter_black.svg"/>
            <img class="pl2" src="@/assets/img/social-media/icon_menu_instagram_black.svg"/>
            <img class="pl2" src="@/assets/img/social-media/icon_menu_pinterest_black.svg"/>
        </MenuSection>
        <MenuSection class="pa3 hover-bg-light-gray pointer">
            <span style="font-weight: 500" class="formLabel">Get in touch: </span><span class="formLabel b"><MailTo address="inquiry@tooliaba.com" subject="Inquiry"/></span>
        </MenuSection>
    </div>
</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import MenuSection from '@/components/header/nav-items/MenuSection.vue';
import MailTo from '@/components/global/MailTo.vue';
import ListItem from '@/components/controls/ListItem.vue';

export default {
    components: {
        TooliabaButton,
        MenuSection,
        MailTo,
        ListItem
    }
};
</script>
